import Login from "./AuthPages/Login/Index";
import Otp from "./AuthPages/Otp/Index";
import SignUp from "./AuthPages/Signup/Index";
import ForgotPassword from "./AuthPages/forgotPassword/Index";
import ResetPassword from "./AuthPages/resetPassword/Index";
import CharacterSetting from "./SideTabPages/CharacterSetting";
import CharacterView from "./SideTabPages/CharacterSetting/View";
import ContentPage from "./SideTabPages/ContentPage";
import Dashboard from "./SideTabPages/Dashboard";
import Language from "./SideTabPages/Language";
import Profile from "./SideTabPages/Profile";
import Setting from "./SideTabPages/Setting";
import Subscsription from "./SideTabPages/Subscription";
import TokenPackage from "./SideTabPages/TokenPackage";
import ManageUsers from "./SideTabPages/Users";
import AddSubscription from "./SideTabPages/Subscription/add";
import SubscriptionDetail from "./SideTabPages/Subscription/detail";
import EditSubscription from "./SideTabPages/Subscription/edit";
import Transaction from "./SideTabPages/Transaction";
import UserView from "./SideTabPages/Users/detail";
import PublicCharacter from "./SideTabPages/CharacterManage/PublicCharacter";
import AddCharacterType from "./SideTabPages/CharacterSetting/Add";
import EditCharacterType from "./SideTabPages/CharacterSetting/edit";
import HomePage from "./SideTabPages/HomePage";
import AddHome from "./SideTabPages/HomePage/add";
import EditHome from "./SideTabPages/HomePage/edit";
import PublicView from "./SideTabPages/CharacterManage/PublicCharacter/DetailsPublic";
import UserRevenue from "./SideTabPages/Revenue/UserRevenue";
import ViewCharacterRevenue from "./SideTabPages/Revenue/UserRevenue/detail";
import UserTransactionPage from "./SideTabPages/Payments/UserTransaction";
import SubscriptionPayment from "./SideTabPages/Payments/SubscriptionPayment";
import TokenPayments from "./SideTabPages/Payments/TokenPayment";
import AddUser from "./SideTabPages/Users/add";
import CreateAi from "./SideTabPages/create-avtar";
import AddToken from "./SideTabPages/TokenPackage/add"
import EditToken from "./SideTabPages/TokenPackage/edit"
import RequestsModule from "./SideTabPages/Requests";

export const routes = [
  { path: "/login", component: <Login /> },
  { path: "/signup", component: <SignUp /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/otp", component: <Otp /> },
  { path: "/reset-password", component: <ResetPassword /> },
];

export const privateRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/subscription-plan", component: <Subscsription /> },
  { path: "/user", component: <ManageUsers /> },
  { path: "/user/add", component: <AddUser /> },
  { path: "/user/:id", component: <UserView /> },
  { path: "/page", component: <ContentPage /> },
  { path: "/subscription-plan/add", component: <AddSubscription /> },
  { path: "/subscription-plan/:id", component: <EditSubscription /> },
  { path: "/subscription-plan/detail/:id", component: <SubscriptionDetail /> },
  { path: "/profile", component: <Profile /> },
  { path: "/setting", component: <Setting /> },
  { path: "/token", component: <TokenPackage /> },
  { path: "/homepage", component: <HomePage /> },
  { path: "/homepage/add", component: <AddHome /> },
  { path: "/homepage/:id", component: <EditHome /> },
  { path: "/character-setting", component: <CharacterSetting /> },
  { path: "/character-setting/add", component: <AddCharacterType /> },
  { path: "/character-setting/:id", component: <EditCharacterType /> },
  { path: "/public-character", component: <PublicCharacter /> },
  { path: "/public-character/:id", component: <PublicView /> },
  { path: "/transaction", component: <Transaction /> },
  { path: "/character-setting/:id", component: <CharacterView /> },
  { path: "/language", component: <Language /> },
  { path: "/revenue", component: <UserRevenue /> },
  { path: "/revenue/:id", component: <ViewCharacterRevenue /> },
  { path: "/user-transaction", component: <UserTransactionPage /> },
  { path: "/subscription-payment", component: <SubscriptionPayment /> },
  { path: "/token-payment", component: <TokenPayments /> },
  { path: "/create-ai", component: <CreateAi /> },
  { path: "/requests", component: <RequestsModule /> },
  { path: "/token/add", component: <AddToken /> },
  { path: "/token/:id", component: <EditToken /> },
];
